/** @jsx h */
import { labels } from '../config';
import { Fragment } from 'preact';

const FilterRemoveAll = ({ pluginNamespace, resetFilters }) => {
  function handleReset() {
    resetFilters();
    // resetFilters(false, [`${pluginNamespace}[q]`]);
  }

  return (
    <Fragment>
      <button
        className="search-form__reset-button"
        onClick={handleReset}
        type="button"
      >
        <span className="icon icon--refresh">
          <svg className="icon__svg" role="img" aria-hidden="true">
            <use href="#icon-refresh" />
          </svg>
        </span>
        <span className="styled-button__text">
          {labels.faceting.removeAllFilters}
        </span>
      </button>
    </Fragment>
  );
};

export default FilterRemoveAll;
